import { useChallenges } from '../hooks/useChallenges'
import { ChallengeCard } from '../components/ChallengeCard'
import { toast } from 'react-hot-toast'
import { useAuth } from '../hooks/useAuth'
import { supabase } from '../lib/supabase'

export function HomePage() {
  const { challenges, loading } = useChallenges()
  const { user } = useAuth()

  const handleParticipate = async (challengeId: string) => {
    if (!user) {
      toast.error('Vous devez être connecté pour participer')
      return
    }

    try {
      const { error } = await supabase
        .from('submissions')
        .insert({
          challenge_id: challengeId,
          user_id: user.id,
          content_url: '', // Will be updated when user submits their work
          description: '',
        })

      if (error) throw error
      toast.success('Participation enregistrée')
    } catch (error) {
      console.error('Error participating in challenge:', error)
      toast.error('Erreur lors de la participation')
    }
  }

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-[50vh]">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-indigo-600"></div>
      </div>
    )
  }

  return (
    <div className="container mx-auto px-4">
      <h1 className="text-3xl font-bold mb-8">Défis en cours</h1>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {challenges.map((challenge) => (
          <ChallengeCard
            key={challenge.id}
            challenge={challenge}
            onParticipate={handleParticipate}
          />
        ))}
      </div>
    </div>
  )
}